if (!customElements.get('back-in-stock-form')) {
    class BackInStockForm extends HTMLElement {
        constructor() {
            super();
            this.form = this.querySelector('form');
            this.form.addEventListener('submit', this.submit.bind(this));
            this.variantInput = this.querySelector('input[name="variant_id"]');
            this.message = this.querySelector('.newsletter-form__message');
            this.errorMessage = this.getAttribute('data-error-message') || 'An error occurred. Please try again.';
            this.successMessage = this.getAttribute('data-success-message') || 'Submitted sucessfully!';
        }

        connectedCallback() {
            document.addEventListener('variant-selects-changed', this.handleVariantChange);
            document.addEventListener('variant:drawer:click', this.handleVariantChange);
        }

        submit(event) {
            event.preventDefault();
            const formData = new FormData(this.form);
            fetch('/apps/orders/mailchimp/add-tag', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: formData.get('email'),
                    variantId: this.variantInput.value,
                })
            }).then((response) => {
                if(response.ok){
                    this.message.textContent = this.successMessage;
                    this.message.classList.add('success');
                    this.toggleActive(this.message);
                    setTimeout(() => {
                        this.toggleActive(this.message, false);
                    }, 3000);
                }
                else{
                    this.message.textContent = this.errorMessage;
                    this.message.classList.add('error');
                    this.toggleActive(this.message);
                    setTimeout(() => {
                        this.toggleActive(this.message, false);
                    }, 3000);
                }
            })
        }

        toggleActive(element, isActive=true){
            element.classList.toggle('active', isActive);
        }

        handleVariantChange = (event) => {
            const isDrawer = event.type == 'variant:drawer:click';
            const element = isDrawer ? event?.detail?.optionElement : event?.detail?.variant ;
            if(!element) return;
            const variantAvailable =  isDrawer ? element.getAttribute('data-bundle-product-available') === 'true' : element.available;
            const variantHide = isDrawer ? element.getAttribute('data-bundle-product-hide-back-in-stock') : element.hide_back_in_stock;
            const shouldHideForm = variantAvailable || variantHide ;
            this.toggleActive(this, !shouldHideForm);
            this.variantInput.value = isDrawer ? element.getAttribute('data-bundle-product') : element.id;
        }
    }
    customElements.define('back-in-stock-form', BackInStockForm);
}